import React from 'react';
import { Space } from 'antd';
import EditCatalogLabTestButton from './EditCatalogLabTestButton';

const ActionsColumn = ({ columnData, onUpdateLabTest, getLabCompanyBranchInfo }) => (
  <Space>
    <EditCatalogLabTestButton
      columnData={columnData}
      onUpdateLabTest={onUpdateLabTest}
      getLabCompanyBranchInfo={getLabCompanyBranchInfo}
    />
  </Space>
);
export default ActionsColumn;
